import React from "react";
import PropTypes from "prop-types";
import { Col, Card, CardBody, Row } from "reactstrap";
import styled from "styled-components";
import { numberWithCommas } from "../../helpers/utils";

const MiniWidget = props => {
  const spinnerWidget = (
    <div className="loader-for-react-widget">
      <div className="spinner-border text-primary m-1" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      {props.data.map((report, key) => (
        <React.Fragment key={key}>
          {report.type === "WITH_DIFFERENCE" ? (
            <Col
              xl={3}
              md={6}
              key={key}
              style={{ height: 105, marginBottom: 24 }}
            >
              <StyledCard style={{ height: 105 }}>
                <CardBody>
                  {props.loading && spinnerWidget}
                  <div
                    className="d-flex align-items-center mb-3"
                    style={{ height: 20 }}
                  >
                    <Row>
                      <Col>
                        <div className="d-flex align-items-center">
                          <div className="avatar-xs me-3">
                            <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18 fade-in-custom-animate">
                              <i className={report.icon} />
                            </span>
                          </div>
                          <h5 className="font-size-14 mb-0 fade-in-custom-animate">
                            {report.title}
                          </h5>
                        </div>
                      </Col>
                    </Row>
                    <div className="w-100 d-flex justify-content-end">
                      <div>
                        <span
                          className={
                            "badge badge-soft-" +
                            report.color +
                            " font-size-12 fade-in-custom-animate"
                          }
                        >
                          {numberWithCommas(report.badgeValue)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="text-muted mt-4">
                    <h4 className="fade-in-custom-animate">
                      {props.loading ? "-" : numberWithCommas(report.value)}
                      <i
                        className={`mdi mdi-chevron-up ms-1 text-success fade-in-custom-animate ${
                          props.loading && "d-none"
                        }`}
                      />
                    </h4>
                    {/* <div className="d-flex">
                      <span
                        className={
                          "badge badge-soft-" +
                          report.color +
                          " font-size-12 fade-in-custom-animate"
                        }
                      >
                        {numberWithCommas(report.badgeValue)}
                      </span>
                      <span className="ms-2 text-truncate fade-in-custom-animate">
                        {report.desc}
                      </span>
                    </div> */}
                  </div>
                </CardBody>
              </StyledCard>
            </Col>
          ) : (
            <Col xl={2} md={4} sm={4} key={"_col_" + key}>
              <StyledCard className="mini-stats-wid">
                <CardBody>
                  {props.loading && spinnerWidget}
                  <div className="d-flex" style={{ height: "65px" }}>
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium fade-in-custom-animate">
                        {report.title}
                      </p>
                      <h4 className="mb-0 fade-in-custom-animate">
                        {props.loading ? "-" : numberWithCommas(report.value)}
                      </h4>
                    </div>

                    <div className="d-flex justify-content-end align-items-center">
                      <div className="avatar-xs">
                        <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18 fade-in-custom-animate">
                          <i className={report.icon} />
                        </span>
                      </div>
                    </div>

                    {/* <div
                      className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center"
                      style={{ width: 35, height: 35 }}
                    >
                      <span className="avatar-title fade-in-custom-animate">
                        <i className={"bx " + report.icon + " font-size-24"} />
                      </span>
                    </div> */}
                  </div>
                </CardBody>
              </StyledCard>
            </Col>
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

const StyledCard = styled(Card)`
  .loader-for-react-widget {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    right: 0;
    bottom: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.3);
    z-index: 1;
  }
`;

MiniWidget.propTypes = {
  data: PropTypes.any,
  loading: PropTypes.bool,
};

export default MiniWidget;
